import { Component, inject, input, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ContainerId, drawerIds } from '../models/drawer';
import { ContainersService } from '../services/containers.service';

/**
 * Displays a diagram of the front of the Knightmeds
 */
@Component({
  selector: 'app-knightmeds-diagram',
  templateUrl: './knightmeds-diagram.component.html',
  styleUrls: ['./knightmeds-diagram.component.scss'],
  standalone: true,
  imports: [],
})
export class KnightmedsDiagramComponent {
  /** Event that is called when a specific drawer or cabinet is clicked */
  onContainerClicked = output<ContainerId>();

  /** An optional array of labels indexed by container id */
  containerLabels = input<string[]>();

  /** An optional array of warnings to be displayed by container id */
  containerWarnings = input<string[]>();

  /** Optionally highlight the container with this id */
  highlightedContainerId = input<ContainerId | undefined>();

  /** Drawer ids grouped by row, top to bottom -- see models/drawer.ts */
  drawerRows = drawerIds;

  private containersService = inject(ContainersService);

  /** This cabinet's physical color, live from Firestore -- see ContainersService.getCabinetColor() */
  cabinetColor = toSignal(this.containersService.getCabinetColor(), { initialValue: 'maroon' as const });
}
